import { api_url } from "../../../utils";

const EstacionFerroviaria = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=estacion_tren&schema_city=",
    zindex: 3,
    type: "single",
    popup: {
        default: {
            content: {
                es: {
                    name: "Nombre de la estación:",
                },
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.EstacionFerroviaria",
    style: {
        regular: true,
        fillColor: "rgba(141, 190, 193, 1)",
        strokeColor: "rgba(70, 124, 143, 1)",
        strokeWidth: 2,
        strokeLineDash: [],
        points: 4,
        radius: 6,
        angle: 25,
        rotation: 30,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.EstacionFerroviaria.title",
            subtitle: "",
            attribute: "",
            symbol: "diamond",
            legendCustomCssClass:
                "map-legend-symbol-8px map-legend-symbol-border-2px-blue-green-70-124-143",
            class: [
                {
                    fillColor: "rgba(141, 190, 193, 1)",
                    strokeColor: "rgba(141, 190, 193, 1)",
                    strokeWidth: 0,
                    label: "Mobility Indicators Content.layersLegend.EstacionFerroviaria.classes.1",
                },
            ],
        },
    },
};

export default EstacionFerroviaria;
